/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { getCashReceiptsPurchase, getCashReceiptsSales } from '../../../apis/cash-receipts';
import Button from '../../../components/Button';
import Comment from '../../../components/Comment';
import Form from '../../../components/Form';
import Modal, { ModalHeader } from '../../../components/Modal';
import useForm from '../../../hooks/useForm';
import CashInvoiceCancelIssue from './CashInvoiceCancelIssue';
import { isEmpty } from "lodash";
import { ControlTable } from "../../../components/Table";
import { accountName } from '../../../utils/account-name';
import { autoHyphen } from '../../../utils/replace';
import EtcInvoiceMapping from '../Trade/EtcInvoiceMapping';
import systemAlert from '../../../utils/systemAlert';
import { deleteToEtcInvoice } from '../../../apis/invoices';
import { shallowEqual, useSelector } from 'react-redux';

const CashInvoice = ({ open, setOpen, data, setData, invoiceType, submit, permission }) => {
  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions
  }), shallowEqual);


  const [mode] = useState('view');
  const [fields, setFields] = useState([]);
  const [cancelOpen, setCancelOpen] = useState(false);
  // 연관된 거래명세서
  const [mappedInvoiceFields, setMappedInvoiceFields] = useState([]);
  const [mappedInvoiceData, setMappedInvoiceData] = useState([]);

  // 발주서/견적서 매핑하기
  const [isEtcInvoiceMapping, setIsEtcInvoiceMapping] = useState(false);
  const [etcInvoiceMappingData, setEtcInvoiceMappingData] = useState(null);

  const [invoicePermission, setInvoicePermission] = useState({});

  // 매핑된 견적서 / 발주서
  const [mappedEtcInvoiceFields] = useState([
    { title: "구분", key: "etcInvoiceType", onValue: (value) => value === "quotation" ? "견적서" : "발주서" },
    { title: "작성일자", key: "writeDate", type: "date" },
    {
      title: "상호",
      onValue: (_value, _field, data) => {
        return data.supByrType === "sales" ? data["byrCorpName"] : data["supCorpName"];
      }
    },
    {
      title: "대표자명",
      onValue: (_value, _field, data) => {
        return data.supByrType === "sales" ? data["byrRepName"] : data["supRepName"];
      }
    },
    {
      title: "사업자번호",
      onValue: (_value, _field, data) => {
        const value = data.supByrType === "sales" ? data["byrBizNo"] : data["supBizNo"];
        return autoHyphen("comNum", value);
      }
    },
    { title: "대표품목", key: "itemName" },
    {
      title: "공급가액",
      key: "supplyAmt",
      type: "comma"
    },
    {
      title: "세액",
      key: "taxAmt",
      type: "comma"
    },
    {
      title: "합계금액",
      key: "totalAmt",
      type: "comma"
    }
  ]);
  const [mappedEtcInvoiceData, setMappedEtcInvoiceData] = useState([]);

  // 연관된 은행내역
  const [registeredBankTransFields] = useState([
    {
      title: "거래일자",
      key: "tradeTime",
      type: 'date'
    },
    {
      title: "계좌정보",
      key: "bankName",
      onValue: (value, field, data) => {
        return accountName(data.bankName, data.bankAccountNo);
      },
    },
    { title: "입금액", key: "inAmt", type: "comma", className: 'color-red-100' },
    { title: "출금액", key: "outAmt", type: "comma", className: 'color-purple-100' },
    {
      title: "거래자명", key: "traderName"
    },
    {
      title: "입금자명", key: "sendBankAccountHolder"
    },
    {
      title: "적요", key: "remark"
    },
    {
      title: "적요(상세)", key: "detail"
    },
    {
      title: "메모", key: "memo"
    },
    {
      title: "거래처",
      key: "clients",
      onValue: (value, field, data) => {
        return (
          !isEmpty(value) &&
          value.map((client, idx) => (
            <p className="pt-8 pb-8" key={idx}>
              <span className="vertical-middle">{client.name}</span>
            </p>
          ))
        );
      }
    },
  ]);
  const [registeredBankTransData, setRegisteredBankTransData] = useState([]);

  useEffect(() => {
    if (open) {
      getCashInvoice();
    }
  }, [invoiceType, data, open]);


  const getCashInvoice = () => {
    switch (invoiceType) {
      case 'sales':
        // 현금영수증 매출 필드
        setFields([
          [
            { title: '거래일자', key: 'trDt', type: 'date' },
            { title: '발행구분', key: 'issueGb' }
          ],
          [
            { title: '공급가액', key: 'supAmt', transform: ["comma"] },
            { title: '부가세', key: 'taxAmt', transform: ["comma"] },
          ],
          [
            { title: '봉사료', key: 'tip', transform: ["comma"] },
            { title: '합계금액', key: 'totAmt', transform: ["comma"] },
          ],
          [
            { title: '승인번호', key: 'apprNo' },
            { title: '발급수단', key: 'frPartNo' }
          ],
          [
            { title: '거래구분', key: 'trGb' },
          ],
        ]);
        // 연관된 거래명세서 필드
        setMappedInvoiceFields([
          { title: "전송일자", key: "issueDate", type: 'date' },
          { title: "작성일자", key: "writeDate", type: 'date' },
          { title: "상호", key: "byrCorpName" },
          { title: "대표자명", key: "byrRepName" },
          {
            title: "사업자번호",
            key: "byrBizNo",
            transform: "comNum"
          },
          { title: "대표품목", key: "itemName" },
          {
            title: "공급가액",
            key: "supplyAmt",
            type: 'comma'
          },
          {
            title: "세액",
            key: "taxAmt",
            type: 'comma'
          },
          {
            title: "합계금액",
            key: "totalAmt",
            type: 'comma'
          },
        ]);
        // 현금영수증 데이터
        getCashReceiptsSales(data.idx).then((res) => {
          setOriginForm(res.data);
          setForm(res.data);
          setRegisteredBankTransData(res.data.registeredBankTrans);
          setMappedInvoiceData(res.data.mappedInvoices);
          setMappedEtcInvoiceData(res.data.mappedEtcInvoices);
        });
        break;
      case 'purchase':
        // 현금영수증 매입 필드
        setFields([
          [
            { title: '거래일자', key: 'trDt', type: 'date' },
            { title: '사업자명', key: 'useStore' }
          ],
          [
            { title: '사업자등록번호', key: 'storeNo', transform: ["comNum"] },
            { title: '공급가액', key: 'supAmt', transform: ["comma"] }
          ],
          [
            { title: '부가세', key: 'taxAmt', transform: ["comma"] },
            { title: '봉사료', key: 'tip', transform: ["comma"] }
          ],
          [
            { title: '합계금액', key: 'totAmt', transform: ["comma"] },
            { title: '승인번호', key: 'apprNo' }
          ],
          [
            { title: '거래구분', key: 'trGb' },
            { title: '발행구분', key: 'bmanClNm' }
          ],
        ]);
        // 연관된 거래명세서 필드
        setMappedInvoiceFields([
          { title: "전송일자", key: "issueDate", type: 'date' },
          { title: "작성일자", key: "writeDate", type: 'date' },
          { title: "상호", key: "supCorpName" },
          { title: "대표자명", key: "supRepName" },
          {
            title: "사업자번호",
            key: "supBizNo",
            transform: "comNum"
          },
          { title: "대표품목", key: "itemName" },
          {
            title: "공급가액",
            key: "supplyAmt",
            type: 'comma'
          },
          {
            title: "세액",
            key: "taxAmt",
            type: 'comma'
          },
          {
            title: "합계금액",
            key: "totalAmt",
            type: 'comma'
          },
        ]);
        // 현금영수증 매입 데이터
        getCashReceiptsPurchase(data.idx).then((res) => {
          setOriginForm(res.data);
          setForm(res.data);
          setRegisteredBankTransData(res.data.registeredBankTrans);
          setMappedInvoiceData(res.data.mappedInvoices);
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  const cancel = () => {
    setOpen(false);
    setData({});
  };

  const defaultForm = {
    tradeTime: '',
    useStore: '',
    storeNo: '',
    supAmt: '',
    taxAmt: '',
    tip: '',
    totAmt: '',
    apprNo: '',
    trGb: '',
    bmanClNm: '',
  };

  const {
    form,
    errors,
    handleOnChange,
    setForm,
    setOriginForm,
    setValidateFields
  } = useForm(defaultForm, {}, () => { });

  const handleCancelIssue = () => {
    setCancelOpen(true);
  };

  const mappedEtcInvoiceRowBtnConfig = {
    title: "삭제",
    rowButtons: [
      {
        type: "delete",
        action: (data) => {
          systemAlert(`연관 견적서/발주서를 삭제하시겠습니까?`, {
            buttons: [
              {
                color: "text",
                label: "취소"
              },
              {
                label: "확인",
                onClick: () => {
                  deleteToEtcInvoice("cashReceipt", { idx: [data.etcInvoiceToCashReceipt?.idx] })
                    .then(() => {
                      getCashInvoice();
                    }).catch(() => { })
                    .finally(() => { });
                }
              }
            ]
          });
        },
      },
    ]
  };


  useEffect(() => {
    if (!isEmpty(permissions)) {
      setInvoicePermission(permissions.find(p => p.code === "TRADE_INVOICE"));
    }
  }, [permissions]);

  return (
    <>
      <Modal isOpen={open} close={cancel}>
        <div className="cash-invoice">
          <ModalHeader>현금 영수증 {invoiceType === 'sales' ? '매출' : '매입'} {mode === 'create' ? '발급' : '상세'}</ModalHeader>
          <div className="button-warp">
            <Button
              className="print-button print-out"
              color="gray-line"
              label="인쇄"
              onClick={() => window.print()}
            />
            {invoiceType === 'sales' && data.trGb !== "취소거래" && (
              <Button
                className="cancel-button print-out"
                label="취소 발행"
                onClick={handleCancelIssue}
              />
            )}

            {/* {permission.level > 1 && ( */}
            <Button
              className="print-button print-out ml-8"
              color="gray-line"
              label="견적서/발주서 매핑"
              disabled={isEmpty(invoicePermission)}
              onClick={() => {
                setIsEtcInvoiceMapping(true);
                setEtcInvoiceMappingData(data);
              }}
            />
            {/* )} */}
          </div>
          <Form
            mode={mode}
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            onChange={handleOnChange}
          />
          {!isEmpty(mappedInvoiceData) && (
            <div className="mapped-data-container">
              <label className="related-header-title">
                연관 거래명세서
              </label>
              <ControlTable fields={mappedInvoiceFields} list={mappedInvoiceData} />
            </div>
          )}
          {!isEmpty(registeredBankTransData) && (
            <div className="mapped-data-container">
              <label className="related-header-title">
                연관 은행내역
              </label>
              <ControlTable fields={registeredBankTransFields} list={registeredBankTransData} />
            </div>
          )}

          {!isEmpty(mappedEtcInvoiceData) && (
            <div className="mapped-tax-invoice-container">
              <label className="related-header-title">
                연관 견적서/발주서
              </label>
              <ControlTable
                fields={mappedEtcInvoiceFields}
                list={mappedEtcInvoiceData}
                rowBtn={permission.level > 1 ? mappedEtcInvoiceRowBtnConfig : {}}
              />
            </div>
          )}
          <Comment
            postIdx={data.idx}
            postType={invoiceType === 'sales' ? "cash_receipt_sales" : "cash_receipt_purchase"}
            submit={submit}
          />
          <Button label="취소" color="text" className="float-right mt-10" action={cancel} />
        </div>
      </Modal>
      {cancelOpen && (
        <CashInvoiceCancelIssue
          open={cancelOpen}
          setOpen={setCancelOpen}
          submit={submit}
          data={data}
        />
      )}

      {/* 견적서or발주서 매핑하기 */}
      {isEtcInvoiceMapping && (
        <EtcInvoiceMapping
          open={isEtcInvoiceMapping}
          setOpen={setIsEtcInvoiceMapping}
          data={etcInvoiceMappingData}
          setData={setEtcInvoiceMappingData}
          listSubmit={getCashInvoice}
          requesterType={"cashReceipt"}
          cashReceipt={invoiceType}
        />
      )}
    </>
  );
};

export default CashInvoice;